const TRADING_LIMIT = {
  description:
    'Kamu bisa menyimpan posisi leverage maksimal hingga T+3 setelah tanggal transaksi. Biaya harian sebesar 0.10% akan berlaku mulai dari T+3. Aturan Forced Sell akan diberlakukan pada T+4.',
};

const DAY_TRADE = {
  description:
    'Kamu harus menjual semua posisi day trade pada pukul %CLOSE_TIME% WIB di hari trading yang sama. Tidak ada biaya tambahan berlaku.',
};

const DAY_TRADE_UNAVAILBALE_REASON = {
  OUTSIDE_MARKET_HOURS:
    'Pembelian saham-saham Day Trade dapat dilakukan di hari bursa sampai pukul %CLOSE_TIME% WIB. Day Trade akan tersedia kembali pada hari bursa mulai pukul %OPEN_TIME% WIB.',
  EXCEED_DEBT_RATIO:
    'Debt Ratio kamu sudah mencapai limit. Silakan melakukan penjualan aset atau menunggu hingga proses forced sell selesai.',
  MAX_DEBT_LIMIT:
    'Kamu sudah menggunakan seluruh kuota Day Trade kamu. Jual sebagian saham kamu untuk menggunakan Day Trade kembali',
  ZERO_BALANCE:
    'Saldo kamu tidak mencukupi untuk melakukan pembelian dengan menggunakan Day Trade.',
};

export default {
  TRADING_LIMIT,
  DAY_TRADE,
  DAY_TRADE_UNAVAILBALE_REASON,
};
